import React, { type FC, useState } from "react";
import { useApiCall, ValidationError } from "../api/api";
import { Input } from "../components/form/Input";
import { ModalFooter } from "../components/layout/ModalProvider";
import { useRefresh } from "../components/RefreshController";

export const AddCompanyModal: FC<{}> = () => {
  const { addCompany } = useApiCall();
  const refresh = useRefresh();
  const [name, setName] = useState<string>("");
  const [errors, setErrors] = useState<string[]>([]);

  const save = async () => {
    await addCompany(name).catch((e) => {
      if (e instanceof ValidationError) {
        setErrors(Object.values(e.errors).flat());
      }
      throw e;
    });
    refresh();
  };
  return (
    <>
      <Input type={"text"} label={"Bedrijfsnaam"} value={name} onChange={setName} />
      <ModalFooter text={"Opslaan"} onSubmit={save} />
    </>
  );
};
